export default __webpack_public_path__ + "static/media/img-0599-liechtenstein-full-face.e036923e.png";